import React, { Fragment, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import logoTechMatch from "./../../../img/rexcornu_techmatch_logo_20230410_01.svg";
import { Grid, Typography, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import navBoard from "./../../../img/nav-board.svg";
import naviPc from "./../../../img/nav-pc.svg";
import { globalContext } from "../../../App";
import {
  useLocalStorage,
  useLocalStorageValue,
  removeLocalStorage,
} from "../../../hooks/localStrage";

const CustomButton = styled(Button)({
  "&:hover": {
    borderBottom: "1px solid #1F1F1F",
    backgroundColor: "#F2F3F4",
  },
});

export default function ElementPc() {
  const { setRerendering, rerendering } = useContext(globalContext);
  const navigate = useNavigate();
  const [, setCurrentPage] = useLocalStorage("currentPage");
  const currentPageVal = useLocalStorageValue("currentPage");
  const adminFlag = Number(localStorage.getItem("adminFlag"));

  const handleCloseNavMenu = (url, currentPage) => {
    setCurrentPage(currentPage);
    navigate(url);
    setRerendering(!rerendering);
  };
  
  const handleLogout = () => {
    removeLocalStorage([
      "token",
      "PersonnelSearchCriteriaFromConditions",
      "PersonnelSearchCriteriaFromRecruitment",
      "recuruitmentSearchCondition",
    ]);
    window.localStorage.removeItem("token");
    handleCloseNavMenu("/", process.env.REACT_APP_DASHBOARD_NUM);
  };
  
  const isLargeScreen = useMediaQuery("(min-width: 771px)");

  // 共通のナビゲーションボタンを描画するヘルパー関数
  const renderNavButton = ({ label, targetPageNum, targetUrl, icon, isImage }) => {
    const isActive = currentPageVal === targetPageNum;
    return (
      <CustomButton
        disableRipple
        startIcon={!isImage && icon}
        onClick={() => handleCloseNavMenu(targetUrl, targetPageNum)}
        sx={{
          color: "black",
          fontSize: 14,
          borderBottom: 1,
          borderColor: isActive ? "#1F1F1F" : "transparent",
          marginRight: "5px",
        }}
        style={{ borderRadius: 0 }}
      >
        {isImage && <><img src={icon} width="16px" height="16px" alt="" />&nbsp;</>}
        {label}
      </CustomButton>
    );
  };

  return (
    <Fragment>
      <Box sx={{ display: "flex", height: "80px" }}>
        <Box sx={{ height: "80px", width: "240px" }}>
          <Link
            to="/dashboard"
            onClick={() => {
              setCurrentPage(process.env.REACT_APP_DASHBOARD_NUM);
            }}
          >
            <img src={logoTechMatch} height={"100"} width="240px" alt="TechMatch Logo" />
          </Link>
        </Box>
        <Box sx={{ flex: 1 }}>
          <Button
            sx={{
              display: "block",
              ml: "auto",
              mr: "0px",
              height: "40px",
              width: "150px",
              mb: "5px",
            }}
            variant="contained"
            color="error"
            onClick={() =>
              handleCloseNavMenu(
                "projectRegister",
                process.env.REACT_APP_DASHBOARD_NUM
              )
            }
          >
            募集登録
          </Button>
          <Grid container justifyContent="flex-end" alignContent="end">
            
            {renderNavButton({
              label: "ダッシュボード",
              targetPageNum: process.env.REACT_APP_DASHBOARD_NUM,
              targetUrl: "dashboard",
              icon: <HomeOutlinedIcon sx={{ fontSize: 16 }} />
            })}

            {renderNavButton({
              label: "要員",
              targetPageNum: process.env.REACT_APP_PERSONNELLIST_NUM,
              targetUrl: "personnelListPage",
              icon: naviPc,
              isImage: true
            })}

            {renderNavButton({
              label: "募集",
              targetPageNum: process.env.REACT_APP_RECRUITMENTLIST_NUM,
              targetUrl: "recruitmentListPage",
              icon: navBoard,
              isImage: true
            })}

            {adminFlag === Number(process.env.REACT_APP_GENERAL_CLASS) &&
              renderNavButton({
                label: "ユーザ情報変更",
                targetPageNum: process.env.REACT_APP_USERCHANGEINFO_NUM,
                targetUrl: "userChangeInfo",
                icon: <PersonOutlineIcon />
              })}

            {(adminFlag === Number(process.env.REACT_APP_BP_MANAGEMENT_CLASS) ||
              adminFlag === Number(process.env.REACT_APP_MANAGEMENT_CLASS)) &&
              renderNavButton({
                label: "ユーザ管理",
                targetPageNum: process.env.REACT_APP_ADMINMANAGEMENT_NUM,
                targetUrl: "adminManagement",
                icon: <PersonOutlineIcon />
              })}

            <CustomButton
              disableRipple
              startIcon={<LogoutIcon />}
              onClick={() => handleLogout()}
              sx={{
                color: "black",
                fontSize: 14,
                borderBottom: 1,
                borderColor: "transparent",
              }}
              style={{ borderRadius: 0 }}
            >
              ログアウト
            </CustomButton>
          </Grid>
          
          <Grid container justifyContent="flex-end" alignContent="end">
            <CustomButton
              disableRipple
              startIcon={<MenuBookIcon />}
              onClick={() =>
                window.open(
                  "https://dwarfstella.atlassian.net/wiki/spaces/TechMatchm/pages/33849348/TechMatch",
                  "_blank"
                )
              }
              sx={{
                color: "black",
                fontSize: 14,
                marginRight: "5px",
              }}
              style={{ borderRadius: 0 }}
            >
              <Typography fontSize={14}>マニュアル</Typography>
            </CustomButton>

            <CustomButton
              disableRipple
              startIcon={<HelpOutlineIcon />}
              onClick={() =>
                window.open(
                  "https://dwarfstella.atlassian.net/wiki/spaces/TechMatchm/pages/33914881/TechMatch+FAQ",
                  "_blank"
                )
              }
              sx={{
                color: "black",
                fontSize: 14,
              }}
              style={{ borderRadius: 0 }}
            >
              <Typography fontSize={14}>FAQ</Typography>
            </CustomButton>
          </Grid>
        </Box>
      </Box>
      <Box
        sx={{
          marginBottom: isLargeScreen ? "10px" : "40px",
        }}
        className="custom-scrollbar"
      />
    </Fragment>
  );
}
